import React from "react";
import { motion } from "framer-motion";
import { X, Sparkles } from "lucide-react";

// Reusable, on-brand festival greeting banner (used live + in admin preview).
export default function FestivalView({ fest, onClose }) {
  if (!fest) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative bg-[#1A1A1A] text-[#F9F6F0] border-b border-[#C9A66B]/40 overflow-hidden"
      data-testid="festival-banner"
    >
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#C9A66B] to-transparent" />
      <div className="max-w-7xl mx-auto px-5 py-4 pr-10 flex flex-col md:flex-row items-center gap-5">
        {fest.image ? (
          <img src={fest.image} alt={fest.name || "Festival"} className="w-full md:w-40 h-32 md:h-20 object-cover rounded-sm shrink-0" />
        ) : (
          <Sparkles className="text-[#C9A66B] shrink-0" size={26} />
        )}
        <div className="flex-1 text-center md:text-left min-w-0">
          {fest.name ? <p className="label-tag text-[#C9A66B] text-[0.6rem] mb-1">{fest.name}</p> : null}
          <h3 className="serif text-2xl md:text-3xl leading-tight">{fest.title}</h3>
          {fest.message ? <p className="text-white/70 text-sm mt-1">{fest.message}</p> : null}
        </div>
        {fest.cta_text && fest.cta_url ? (
          <a href={fest.cta_url} target="_blank" rel="noopener noreferrer" data-testid="festival-cta"
            className="btn-gold px-6 py-3 rounded-sm text-sm shrink-0 w-full md:w-auto text-center">{fest.cta_text}</a>
        ) : null}
      </div>
      {onClose ? (
        <button onClick={onClose} data-testid="festival-banner-close" aria-label="Dismiss"
          className="absolute top-3 right-4 text-white/60 hover:text-white transition-colors"><X size={18} /></button>
      ) : null}
    </motion.div>
  );
}
